import gql from 'graphql-tag'

export default gql`
query searchRecipients($recipient: String!) {
  labels(
    sort: _ID_DESC
    filter: {
      recipient: $recipient
    }
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchRecipients.js